export function soundPlay() {
	const musicIcon = document.getElementById("musicIcon");
	const audioElement = document.getElementById("audioElement");
	const soundon = document.getElementById("soundon");
	const soundoff = document.getElementById("soundoff");
  
	const defaultVolume = 0.3;
	let isPlaying = true;
  
	audioElement.volume = defaultVolume;
  
	musicIcon.addEventListener("click", toggleMusic);
  
	function toggleMusic() {
	  isPlaying = !isPlaying;
	  isPlaying ? audioElement.play() : audioElement.pause();
	  soundon.classList.toggle("visible", isPlaying);
	  soundon.classList.toggle("hidden", !isPlaying);
	  soundoff.classList.toggle("visible", !isPlaying);
	  soundoff.classList.toggle("hidden", isPlaying);
	}
  }